<!-- Aplicación -->
<section class="app-container">
  <!-- Navbar de la aplicación: botón de sidebar, icono de notificaciones y
        detalles del usuario -->
  @if (!fullScreen){
  <div class="sticky-navbar-container">
    <app-navbar class="sticky-navbar"></app-navbar>
  </div>
  }

  <!-- Contenido de la aplicación -->
  <div class="router-outlet-container scrollable-content">
    <router-outlet></router-outlet>
  </div>
</section>
<footer>
  <img src="assets/static/images/ES_Financiado_por_la_Unión_Europea_RGB_POS.png" alt="">
</footer>

<style></style>
